<template>
  <div class="changePaw-forget" :style="{ background: bgImg ? bgImg : '' }">
    <div class="stars"></div>
    <div class="info-box">
      <div class="describe">
        <div class="title">{{homeFile.title?homeFile.title:'四川省雪亮工程云平台'}}</div>
        <p><span>{{homeFile.titlePinyin?homeFile.titlePinyin:'Xueliang Project of Sichuan Province'}}</span></p>
      </div>

      <div class="detailsBox" v-if="active == 1">
        <div class="stepsBox">
          <el-steps :active="active">
            <el-step title="安全验证" icon="el-icon-mobile-phone"></el-step>
            <el-step title="修改密码" icon="el-icon-setting"></el-step>
          </el-steps>
        </div>
        <div class="column details">
          <span class="tit">电话号码</span>：
          <el-input v-model="phone" placeholder="请输入电话号码"></el-input>
        </div>
        <div class="column note">
          <span class="tit">验证码</span>：
          <el-input v-model="authCode" placeholder="请输入验证码"></el-input>
          <div class="get-code">
            <el-button
              style="margin: 0 10px"
              size="mini"
              type="primary"
              :loading="loading2"
              :disabled="codeDisabled"
              @click="getSMS"
              >{{ codeMeg }}</el-button
            >
          </div>
        </div>
        <div style="text-align: center" class="goBack-login">
          <el-button @click="goLogin">返回登录</el-button>

          <el-button type="primary" :loading="loading" @click="nextStep"
            >下一步</el-button
          >
        </div>
      </div>

      <div class="detailsBox" v-if="active === 2">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-position="right"
          label-width="100px"
        >
          <el-form-item label="新密码" prop="password">
            <el-input
              style="width: 100%"
              v-model="ruleForm.password"
              placeholder="请输入新密码"
            ></el-input>
          </el-form-item>
          <el-form-item label="重复新密码" prop="confirmPwd">
            <el-input
              style="width: 100%"
              v-model="ruleForm.confirmPwd"
              placeholder="请再次输入新密码"
            ></el-input>
          </el-form-item>
          <div  class="goBack-login" style="display: flex; justify-content: center">
            <el-button @click="active = '1'">上一步</el-button>
            <el-button type="primary" :loading="loading" @click="submitForm('ruleForm')"
              >确认修改</el-button
            >
          </div>
        </el-form>
      </div>

      <div class="login-info">
        <p v-if="homeFile.undertakeUnit"><span>承办单位 ：</span><span>{{homeFile.undertakeUnit}}</span></p>
        <p v-if="homeFile.constructionUnit"><span>建设单位 ：</span><span>{{homeFile.constructionUnit}}</span></p>
        <p v-if="homeFile.supportUnit"><span>技术支持 ：</span>{{homeFile.supportUnit}}</p>
      </div>
    </div>
  </div>
</template>

<script>
let Base64 = require("js-base64").Base64;
import { loginApi } from "../../../api-path/login-api";
import publicAPI from "../../../api-path/public-api.js";
const host = window.location.host;
export default {
  name: "changePaw-forget",
  data() {
    return {
      homeFile:{},
      bgImg: "url(" + require("../../../assets/images/login/bg1.jpg") + ")",

      loading2: false,
      loading: false,
      timer: null,
      errorTxt: "",
      countdown: 60,
      codeMeg: "获取验证码",
      codeDisabled: false,
      authCode: "", //验证码
      isGetSMS: false,
      active: 1, //步骤
      phone: "",
      codeTemp: "", //临时吗
      masterInfo: {}, //站长信息

      ruleForm: {
        password: "", //密码，
        confirmPwd: "", //修改密码
      },
      rules: {
        password: [
          { required: true, message: "请设置新密码", trigger: "blur" },
          { validator: this.validateNewPassword, trigger: "blur" },
        ],
        confirmPwd: [
          { required: true, message: "请确认新密码", trigger: "blur" },
          { validator: this.validateNewPassword2, trigger: "blur" },
        ],
      },
    };
  },
  created() {
    // var ary = localStorage.getItem('p').split("");
    // ary.splice(3,4,"****");
    // this.phone=ary.join("");
    this.getHomeFile();
  },
  methods: {
    getHomeFile() {
      this.$http
        .get(publicAPI.version, {
          params: {
            domain: host,
          },
        })
        .then((res) => {
          if (res.status == 200) {
            this.homeFile = res.result;
            this.bgImg =  res.result.bgImg?'url(' + res.result.bgImg + ')':"url(" + require("../../../assets/images/login/bg1.jpg") + ")"
            localStorage.setItem('homeFile',JSON.stringify(res.result))
          }
        });
    },
    validateNewPassword(rule, value, callback) {
      if (value == "") {
        callback(new Error("请输入新密码!"));
      } else {
        var regu = "^[0-9a-zA-Z]{6,16}$";
        var re = new RegExp(regu);
        if (!re.test(value)) {
          callback(new Error("必须为6-16位字母或数字"));
        } else {
          callback();
        }
      }
    },
    validateNewPassword2(rule, value, callback) {
      if (value !== this.ruleForm.password) {
        callback(new Error("与新密码不一致!"));
      } else {
        callback();
      }
    },
    getSMS() {
      //根据站长电话号码获取验证码
      if (this.phone == "") {
        this.$message.error("请输入您的手机号");
        return false;
      }
      if (!/^1[3456789]\d{9}$/.test(this.phone)) {
        this.$message.error("手机号码有误，请重填");
        return false;
      }
      this.loading2 = true;
      this.$http
        .get(loginApi.phoneVerify, { params: { phone: this.phone } })
        .then((res) => {
          if (res.status == 200) {
            if (res.result) {
              this.$http
                .get(loginApi.getCode, { params: { phone: this.phone } })
                .then((res) => {
                  if (res.status === 200) {
                    if (!this.timer) {
                      this.timer = setInterval(() => {
                        if (this.countdown > 0 && this.countdown <= 60) {
                          this.countdown--;
                          if (this.countdown > 0) {
                            this.codeDisabled = true;
                            this.codeMeg = "重新发送(" + this.countdown + ")";
                          } else {
                            clearInterval(this.timer);
                            this.codeDisabled = false;
                            this.codeMeg = "获取验证码";
                            this.countdown = 60;
                            this.timer = null;
                          }
                        }
                      }, 1000);
                    }
                  } else {
                    this.codeDisabled = false;
                  }
                  this.loading2 = false;
                });
            } else {
              this.$message.error(res.msg);
              this.loading2 = false;
            }
          } else {
            this.loading2 = false;
          }
        });
    },
    nextStep() {

      //下一步
      if (!this.authCode) {
        this.$message.error("请输入验证码");
        return;
      }
      this.loading = true;
      this.$http
        .get(loginApi.validateSmsVerifyCode, {
          params: { phone: this.phone, smsCode: this.authCode },
        })
        .then((res) => {
          this.loading = false;
          if (res.status === 200) {
            this.codeTemp = res.result;
            this.active = 2;
            clearInterval(this.timer);
            this.codeMeg = "获取验证码";
            this.countdown = 60;
            this.timer = null;
            this.codeDisabled = false;
          }
        });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let ruleForm = {
            smsCode: this.codeTemp,
            phone: this.phone,
            // password: this.crypto.encrypt(this.ruleForm.password) //密码，
            password: Base64.encode(this.ruleForm.password),
          };
          this.$http.post(loginApi.updatePassword, ruleForm).then((res) => {
            if (res.status === 200) {
              this.$message.success("修改密码成功，可进行登陆操作");
              this.$router.push("/login");
            }
          });
        } else {
          return false;
        }
      });
    },
    goLogin() {
      this.$router.push("/login");
    },
  },
};
</script>

<style lang="less">
@import "changePaw.less";
</style>
